module.exports = __webpack_public_path__ + "img/icon_stop.b79b2834.svg";